import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts';
import boddVariables from '../../../variables.module.scss';
import styles from './BodyCompositionChart.module.scss';

interface BodyCompositionChartProps {
    fatMass: number;
    totalBodyWater: number;
    totalBodyProtein: number;
    totalBodyBoneMaterial: number;
    totalMass: number;
}

const BodyCompositionChart: FC<BodyCompositionChartProps> = (props) => {
    const { fatMass, totalBodyWater, totalBodyProtein, totalBodyBoneMaterial, totalMass } = props;
    const data = [
        { name: 'totalBodyProtein', value: totalBodyProtein, colour: boddVariables.brandRed },
        { name: 'fatMass', value: fatMass, colour: boddVariables.brandPink },
        { name: 'totalBodyWater', value: totalBodyWater, colour: boddVariables.brandBlue },
        { name: 'totalBodyBoneMaterial', value: totalBodyBoneMaterial, colour: boddVariables.brandYellow },
    ];

    return (
        <div
            data-testid="BodyCompositionChart"
            className={styles.BodyCompositionChart}
        >
            <ResponsiveContainer width="85%" aspect={1}>
                <PieChart>
                    <Pie
                        data={data}
                        cx="50%"
                        cy="50%"
                        innerRadius="65%"
                        outerRadius="100%"
                        dataKey="value"
                        isAnimationActive={false}
                    >
                        {data.map((entry) => (
                            <Cell style={{ outline: 'none' }} key={`cell-${entry.name}`} fill={entry.colour} />
                        ))}
                    </Pie>
                </PieChart>
            </ResponsiveContainer>
            <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
            }}
            >
                <Typography sx={{
                    fontFamily: 'Poppins',
                    fontSize: '16px',
                    lineHeight: 'normal',
                    textAlign: 'center',
                    width: '50px',
                }}
                >
                    Total Mass
                </Typography>
                <Typography
                    sx={{
                        fontFamily: 'Poppins',
                        fontSize: '18px',
                        fontWeight: 600,
                        textAlign: 'center',
                        pt: 0.5 }}
                >
                    {`${totalMass.toFixed(1)} kg`}
                </Typography>
            </Box>
        </div>
    );
};

export default BodyCompositionChart;
